import { type FC, useContext } from 'react'

import { Option, Select } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'
import { type DateEntry } from '../../dateOfBirthDropDownUtil'

interface DateDropdownProps {
  'data-qa-id': string
  entries: DateEntry[]
  id: string
  label?: string
  selectField:
    'birthDaySelectedDay' | 'birthDaySelectedMonth' | 'birthDaySelectedYear'
}

export const LoginRegistrationDateDropdown: FC<DateDropdownProps> = ({
  'data-qa-id': dataQaId,
  entries,
  id,
  label,
  selectField,
}) => {
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  return (
    <Select
      className="text-m font-medium"
      data-qa-id={dataQaId}
      id={id}
      onChange={(event, value): void => {
        if (!value) {
          return
        }
        registrationFormState.setValue(value, model, selectField)
      }}
      slotProps={
        label
          ? {
              root: {
                'aria-label': label,
              },
            }
          : {}
      }
      value={model[selectField]}
    >
      {entries.map((entry: DateEntry) => {
        return (
          <Option key={entry.text} value={entry.value}>
            {entry.text}
          </Option>
        )
      })}
    </Select>
  )
}
